<div class="card p-4">
    <div class="card-body">
        <div>

            <h1 class="loginLabel">My Profile</h1>
            <br>

            <form [formGroup]="myProfileFormGroup" autocomplete="off">
                <!-- <div *ngIf="!forgetPasswordMode"> -->
                <div class="form-group">
                    <div class="row col-md-12">
                        <label class="support-label col-md-3 col-sm-12 pl-0" for="inputUserName">First Name <span
                                class="required-field">*</span></label>
                        <input nbInput fullWidth fieldSize="giant" formAutoFocus type="text"
                            class="form-control col-md-9 col-sm-12" id="inputUserName" placeholder="First Name"
                            formControlName="fname"
                            [ngClass]="{ 'is-invalid': isCheckValidation && myProfileControls.fname.errors }">
                    </div>
                    <small class="form-error-text col-md-12 offset-md-3 offset-sm-0" *ngIf="(isCheckValidation && !!myProfileControls?.fname.errors) ||
                        (!!myProfileControls?.fname.touched && !!myProfileControls?.fname.invalid)">
                        <ng-container class="pt-2" *ngIf="!!myProfileControls?.fname.errors.required">
                            {{ myProfileMessage.fname.errors.required }}
                        </ng-container>
                    </small>
                </div>

                <div class="form-group">
                    <div class="row col-md-12">
                        <label class="support-label col-md-3 col-sm-12 pl-0" for="inputUserName">Last Name <span
                                class="required-field">*</span></label>
                        <input nbInput fullWidth fieldSize="giant" formAutoFocus type="text"
                            class="form-control col-md-9 col-sm-12" id="inputUserName" placeholder="Last Name"
                            formControlName="lname"
                            [ngClass]="{ 'is-invalid': isCheckValidation && myProfileControls.lname.errors }">
                    </div>
                    <small class="form-error-text col-md-12 offset-md-3 offset-sm-0" *ngIf="(isCheckValidation && !!myProfileControls?.lname.errors) ||
                        (!!myProfileControls?.lname.touched && !!myProfileControls?.lname.invalid)">
                        <ng-container class="pt-2" *ngIf="!!myProfileControls?.lname.errors.required">
                            {{ myProfileMessage.lname.errors.required }}
                        </ng-container>
                    </small>
                </div>

                <div class="form-group">
                    <div class="row col-md-12">
                        <label class="support-label col-md-3 col-sm-12 pl-0" for="inputUserName">Email <span
                                class="required-field">*</span></label>
                        <input nbInput fullWidth fieldSize="giant" formAutoFocus type="text"
                            class="form-control col-md-9 col-sm-12" id="inputEmail" placeholder="Email"
                            formControlName="email"
                            [ngClass]="{ 'is-invalid': isCheckValidation && myProfileControls.email.errors }">
                    </div>
                    <small class="form-error-text col-md-12 offset-md-3 offset-sm-0" *ngIf="(isCheckValidation && !!myProfileControls?.email.errors) ||
                  (!!myProfileControls?.email.touched && !!myProfileControls?.email.invalid)">
                        <ng-container class="pt-2" *ngIf="!!myProfileControls?.email.errors.required">
                            {{ myProfileMessage.email.errors.required }}
                        </ng-container>
                        <ng-container class="pt-2" *ngIf="myProfileControls?.email.errors.checkEmail">
                            {{ myProfileMessage.email.errors.invalid }}
                        </ng-container>
                    </small>

                </div>

                <div class="form-group">
                    <div class="row col-md-12">
                        <label class="support-label col-md-3 col-sm-12 pl-0" for="inputUserName">Phone <span
                                class="required-field">*</span></label>
                        <input nbInput fullWidth fieldSize="giant" formAutoFocus type="text"
                            class="form-control col-md-9 col-sm-12" id="inputUserName" placeholder="Phone"
                            formControlName="phone"
                            [ngClass]="{ 'is-invalid': isCheckValidation && myProfileControls.phone.errors }">
                    </div>
                    <small class="form-error-text col-md-12 offset-md-3 offset-sm-0" *ngIf="(isCheckValidation && !!myProfileControls?.phone.errors) ||
                        (!!myProfileControls?.phone.touched && !!myProfileControls?.phone.invalid)">
                        <ng-container class="pt-2" *ngIf="!!myProfileControls?.phone.errors.required">
                            {{ myProfileMessage.phone.errors.required }}
                        </ng-container>
                    </small>
                </div>

                <div id="login-box">
                    <div class="d-flex justify-content-center">
                        <button id="support-btn" class="btn px-4"
                            [disabled]="myProfileFormGroup.invalid || showLoading "
                            (click)="onSubmitClick()">Submit</button>

                        <button id="cancel-btn" class="btn px-4" (click)="onCancel()">Cancel</button>
                    </div>
                </div>

            </form>
        </div>
    </div>
    <div class="text-center">
        <p id="error-message">
            {{ errorMessage }}
        </p>
    </div>
</div>